// extracted by mini-css-extract-plugin
export default {"menuBlock":"oF-z","title":"pF-z","nav":"qF-z","flexCell":"rF-z","facetLink":"sF-z"};